<template>
    <Title_Base :icon="config.icon" :title="config.text">
    </Title_Base>
</template>


<script>
import Title_Base from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_Base.vue";

export default {
    name: 'Title_JobStatusList',
    props: {},
    components: {
        Title_Base,
    },

    data() {
        return {
        };
    },

    methods: {},

    computed: {
        statuses() {
            return this.$store.getters["LookUpStore/JobStatusList"]
        },
        substatuses() {
            return this.$store.getters["LookUpStore/JobSubStatusList"];
        },

        routeFilter() {
            return this.$route.params.filter;
        },

        config() {
            var text,
                icon;

            var key = this.routeFilter;
            if (key == 'my') {
                text = this.$t('servicesystem.pages.page_titles.job_my_jobs');
                icon = 'mdi-briefcase-account';
            }
            else if (key == 'browse') {
                text = this.$t('servicesystem.pages.page_titles.job_browse_jobs');
                icon = 'mdi-briefcase-search';
            }
            else if (key == 'parts') {
                text = this.$t('servicesystem.pages.page_titles.job_parts_jobs');
                icon = 'mdi-fridge-alert';
            }
            else if (key?.includes("user-")) { 
                text = this.$t('servicesystem.pages.page_titles.job_assignments');
                icon = 'mdi-briefcase-account';
            }
            else if (key?.includes("status-")) {
                var split = key.split("-");
                var statusId = parseInt(split[1]);
                var subStatusId = parseInt(split[2]);
                var status = this.statuses.find(x => x.Id == statusId);
                var subStatus = this.substatuses.find(x => x.Id == subStatusId);
                text = status?.Name + (subStatus ? (" / " + subStatus.Name) : "");
                icon = status?.Icon;
            }
            else {
                text = this.$t('servicesystem.common_objects.job.job_list');
                icon = "$job";
            }

            return { text: text, icon: icon };
        },
    },

    watch: {},
};
</script>


<style lang='scss' scoped></style>